import { CommandListBudgets } from "./commands/cmdListBudgets";
import { CommandGetBudget } from "./commands/cmdGetBudget";
import { CommandCreateBudget, CreateBudgetPayload } from "./commands/cmdCreateBudget";
import { CommandUpdateBudget, UpdateBudgetPayload } from "./commands/cmdUpdateBudget";
import { CommandDeleteBudget } from "./commands/cmdDeleteBudget";
import { Budget } from "@models/budget.model";

export class BudgetService {
  async list(params?: {
    contract_id?: number;
    is_active?: boolean;
  }): Promise<Budget[]> {
    try {
      const cmd = new CommandListBudgets();
      return await cmd.run(params);
    } catch (error) {
      console.error("Failed to fetch budgets:", error);
      return [];
    }
  }

  async get(budgetId: number): Promise<Budget | null> {
    try {
      const cmd = new CommandGetBudget();
      return await cmd.run(budgetId);
    } catch (error) {
      console.error(`Failed to fetch budget ${budgetId}:`, error);
      return null;
    }
  }

  async create(payload: CreateBudgetPayload): Promise<Budget> {
    try {
      const cmd = new CommandCreateBudget();
      return await cmd.run(payload);
    } catch (error) {
      console.error("Failed to create budget:", error);
      throw error;
    }
  }

  async update(budgetId: number, payload: UpdateBudgetPayload): Promise<Budget> {
    try {
      const cmd = new CommandUpdateBudget();
      return await cmd.run(budgetId, payload);
    } catch (error) {
      console.error(`Failed to update budget ${budgetId}:`, error);
      throw error;
    }
  }

  async delete(budgetId: number): Promise<Budget> {
    try {
      const cmd = new CommandDeleteBudget();
      return await cmd.run(budgetId);
    } catch (error) {
      console.error(`Failed to delete budget ${budgetId}:`, error);
      throw error;
    }
  }
}